import availableLanguages from '../../resources/languages.json';

export default `/:locale(${availableLanguages.join('|')})?`;
